import IncomeMessageComponent from "./IncomeMessageItemComponent";

export default IncomeMessageComponent;
